module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-sv.1ef4ada05c8e15875208.svg";